
import React, { useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Image, Edit } from "lucide-react";

interface EditShopImageDialogProps {
  open: boolean;
  onClose: () => void;
  currentImage: string;
  onChangeImage: (newImage: string) => void;
}

const EditShopImageDialog: React.FC<EditShopImageDialogProps> = ({
  open,
  onClose,
  currentImage,
  onChangeImage,
}) => {
  const [preview, setPreview] = useState<string>(currentImage);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setImageFile(file);
      const url = URL.createObjectURL(file);
      setPreview(url);
    }
  };

  const handleSubmit = () => {
    // For demo, just use the local preview image
    if (imageFile) {
      onChangeImage(preview);
    }
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit className="w-5 h-5" /> Edit Shop Image
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4">
          <img
            src={preview}
            alt="Shop Preview"
            className="rounded-lg h-40 w-64 object-cover border"
          />
          <label htmlFor="shop-image-upload" className="w-full">
            <Input
              ref={fileInputRef}
              id="shop-image-upload"
              type="file"
              accept="image/*"
              className="w-full"
              onChange={handleFileChange}
            />
          </label>
          <div className="flex gap-3 mt-5">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button onClick={handleSubmit} disabled={!imageFile}>
              Save Image
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditShopImageDialog;
